import { clearStashedAudience } from '@/features/audienceEdit/audienceEditSlice';
import { IconButton } from '@/lib/Buttons';
import { PlusIcon } from '@/lib/Icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

export const AddAudienceButton: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleCreateAudience = () => {
    dispatch(clearStashedAudience());
    history.push('/audiences/create');
  };

  return <IconButton size='lg' leadingIcon={<PlusIcon />} onClick={handleCreateAudience} text={t('audiences:empty_set.button_text')} />;
};
